import { ICreateProjectFormFields } from './CreateProjectForm.interfaces';

const CREATE_PROJECT_FORM_INITIAL_VALUES: ICreateProjectFormFields = {
  project: '',
};

export { CREATE_PROJECT_FORM_INITIAL_VALUES };
